import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
	rightSideWrapper: {
		gap: theme.spacing.xs,
		flexWrap: 'nowrap',
	},
}));
